<div class="section">
  <h1>{{title()}}</h1>
  @if(description()) {
    <p>{{description()}}</p>
  }
</div>